import { useMemo } from 'react'
import { useLearningUiTranslation } from '@features/learning/shared/use-learning-ui-translation'
import type { DashboardUserProfile } from '@services/firebase'
import type { FlashcardCard } from '@services/firebase/flashcards'
import { ImageLightbox } from '@shared/media/lightbox/ImageLightbox'
import { getFlashcardLightboxItems } from '@features/flashcards/shared/flashcard-selectors'

export function FlashcardSlideshowDialog({
  activeIndex,
  cards,
  locale,
  onChange,
  onClose,
  open,
  profile,
}: {
  readonly activeIndex: number
  readonly cards: FlashcardCard[]
  readonly locale: string
  readonly onChange: (activeIndex: number) => void
  readonly onClose: () => void
  readonly open: boolean
  readonly profile: DashboardUserProfile | null
}) {
  const ui = useLearningUiTranslation()
  const items = useMemo(
    () =>
      getFlashcardLightboxItems({
        cards,
        locale,
        profile,
      }),
    [cards, locale, profile],
  )

  if (items.length === 0) {
    return null
  }

  return (
    <ImageLightbox
      activeIndex={activeIndex}
      items={items}
      labels={{
        close: ui('Close slideshow'),
        previous: ui('Show previous image'),
        next: ui('Show next image'),
        audio: {
          play: ui('Play audio'),
          stop: ui('Stop audio'),
          unavailable: ui('Audio playback is unavailable for this clip in the current browser.'),
        },
      }}
      onChange={onChange}
      onClose={onClose}
      open={open}
    />
  )
}
